import Hero from "./sections/Hero";
import ProblemSection from "./sections/ProblemSection";
import SolutionSection from "./sections/SolutionSection";
import BusinessBenefitsSection from "./sections/BusinessBenefitsSection";
import AudienceSection from "./sections/AudienceSection";
import ImpactSection from "./sections/ImpactSection";
import BackingSection from "./sections/BackingSection";

function Home() {
  return (
    <>
      <Hero />
      <ProblemSection />
      <SolutionSection />
      <BusinessBenefitsSection />
      <AudienceSection />
      <ImpactSection />
      <BackingSection />
    </>
  );
}

export default Home;
